import React, { Component } from 'react'
import {GoogleAPI} from '../utils/util-networkCalls.js';

class ContainerDropDown extends Component {
  constructor(props){
    super(props);
    this.state = {
      containerList:undefined
    };
  }
  componentDidMount() {
    //console.log(this.props.accountObject);
    let accountObject = this.props.accountObject;
      GoogleAPI(accountObject.path+'/containers',this.props.token)
      .then(response =>{
      //  console.log(response.container);
        this.setState({
            containerList:response.container
        });
      });
  }

  //On the change event for the select box pass the selected value back to the parent
  handleChange = (event) =>{
      let selectedValue = event.target.value;
      if(typeof this.state.containerList !== 'undefined'){
        this.state.containerList.forEach((container)=>{
            if(container.publicId === selectedValue){
               this.props.getContainerObject(container);
               this.props.isContainerSet(true);
            }
        })
      }
  }

  render() {
    let containerList = this.state.containerList;

    if(typeof containerList !== 'undefined'){

      let options = containerList.map((container) =>
          <option key={container.containerId} value={container.publicId} >
              {container.name} - {container.publicId}
          </option>
      );

      return (
      <div>
         <select onChange={this.handleChange} >
              <option>Select Container</option>
              {options}
         </select>
      </div>
      )
    }else{
      return (
      <div>
          Container Details Loading...
      </div>
      )
    }

  }
}

class AccountDropDown extends Component {
  constructor(props){
    super(props);
    this.state = {
      accountList:undefined
    };
  }

  componentDidMount() {
      GoogleAPI('accounts',this.props.token)
      .then(response =>{
        this.setState({
            accountList:response.account
        });
      });
  }

  //On the change event for the select box pass the selected value back to the parent
  handleChange = (event) =>{
      let selectedValue = event.target.value;
      if(typeof this.state.accountList !== 'undefined'){
        this.state.accountList.forEach((account)=>{
            if(account.name === selectedValue){
              this.props.getAccountObject(account);
              this.props.isAccountSet(true);
            }
        })
      }

  }

  render() {
    let accountList = this.state.accountList;

    if(typeof accountList !== 'undefined'){
      let options = accountList.map((account) =>
          <option key={account.accountId} value={account.name} >
              {account.name}
          </option>
      );
      return (
      <div>
         <select onChange={this.handleChange} >
              <option>Select Item</option>
              {options}
         </select>
      </div>
      )
    }else{
      return (
      <div>
          Account Details Loading...
      </div>
      )
    }

  }
}

class GoogleGtmSelection extends Component {
  constructor(props){
    super(props);
    this.state = {
      accountSet : false,
      containerSet : false,
    };
  }

  isAccountSet = (flag) =>{
    this.setState({accountSet: flag});
  }
  isContainerSet = (flag) =>{
    this.setState({containerSet: flag});
  }
  render() {
    //let accountSet = this.state.accountSet;
    //console.log(accountSet);

    if(this.props.googleAccessToken){
      return (
        <div>
          <AccountDropDown token={this.props.googleAccessToken} getAccountObject={this.props.getAccountObject} isAccountSet={this.isAccountSet} />
          {this.state.accountSet?<ContainerDropDown token={this.props.googleAccessToken} accountObject={this.props.accountObject} getContainerObject={this.props.getContainerObject} isContainerSet={this.isContainerSet} />:null}
       </div>
     )
    } else{
      return(null)
    }
  }
}

export default GoogleGtmSelection;
